import script from "./ListFiles.vue?vue&type=script&setup=true&lang=js"
export * from "./ListFiles.vue?vue&type=script&setup=true&lang=js"

import "./ListFiles.vue?vue&type=style&index=0&id=2a440f56&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a440f56"]])

export default __exports__